import "./testerDetails.scss";
import "../home/Home.scss";
import { reactPlugin } from "../../../../services/appInsights.service";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { useParams, useNavigate } from "react-router-dom";
import { Row, Col, Card, Accordion } from "react-bootstrap";
import { useEffect, useState, useContext } from "react";
import {
  ConfirmationModelPopup,
  Toaster,
  ComponentModelPopup,
} from "../../../../interfaces/modal.interface";
import ViewTester from "../../appSubComponents/ViewTester/ViewTester";
import EditTester from "../../appSubComponents/EditTester/EditTester";
import Vehicles from "../../appSubComponents/Vehicles/Vehicles";
import ToasterModel from "../../appUtilityComponent/ToasterModel/ToasterModel";
import ConfirmationModel from "../../appUtilityComponent/ConfirmationModel/ConfirmationModel";
import ErrorComponentModel from "../../appUtilityComponent/ErrorComponentModel/ErrorComponentModel";
import { Tester } from "../../../../interfaces/tester.interface";
import { TesterService } from "../../../../services/tester.service";
import { ChevronUp, ChevronDown } from "react-bootstrap-icons";
import Spinner from "../../../components/Spinner";
import {
  UserAuthContext,
  Authorize,
} from "../../appLoginComponent/UserAuthContext";
import NotAuthorized from '../../appLoginComponent/NotAuthorized';

interface TParams extends Record<string, string | undefined> {
  testerid?: string;
  vehicleid?: string;
  incidentid?: string;
}

function TesterDetails() {
  const { testerid, vehicleid, incidentid } = useParams<TParams>();
  const navigate = useNavigate();
  const { isAuthorized } = useContext(UserAuthContext) as Authorize;

  const [testerId, setTesterId] = useState<number>(Number(testerid) || 0);
  const [testerEditMode, setTesterEditMode] = useState<boolean>(testerId === 0);
  const [isShowLoading, setIsShowLoading] = useState(false);
  const [toaster, setToaster] = useState<Toaster>({} as Toaster);
  const [modal, /* setModalPopup */] = useState<ConfirmationModelPopup>({} as ConfirmationModelPopup);
  const [errorModal, setErrorModal] = useState<ComponentModelPopup>({
    Title: "Error",
    Show: false,
    Component: null,
    HandleClose: () => setErrorModal({ ...errorModal, Show: false })
  });

  useEffect(() => {
    if (vehicleid && incidentid) {
      sessionStorage.setItem("Incident_VehicleId", vehicleid);
      sessionStorage.setItem("Incident_IncidentId", incidentid);
    }
    navigate(`/tester/${testerId}`);
  }, [testerId]);

  const OnCancel = () => {
    testerId === 0 ? navigate("/") : setTesterEditMode(false);
  };

  const onToasterClose = () => setToaster({} as Toaster);

  const OnSuccess = (tester: Tester) => {
    setToaster({
      Title: "Success",
      Show: true,
      Message: `${tester.testerName} has been saved successfully.`,
      ShowSuccessCheck: true,
      ClassName: "toaster-success",
      OnClose: onToasterClose,
    });
    setTesterId(tester.testerId);
    setTesterEditMode(false);
    if (testerId === 0) navigate(`/tester/${tester.testerId}`);
  };

  const onDeleteConfirmation = (tester: Tester) => {
    setIsShowLoading(true);
    const testerService = new TesterService();

    testerService.SaveTester({ ...tester, isActive: "N" }).then(res => {
      if (res.statusCode === "N") {
        const errorMessage = res.statusMessage || "Failed to delete tester";
        console.error("SaveTester (delete) error:", errorMessage);
        setErrorModal({
          Title: "Error",
          Show: true,
          Component: <div>{errorMessage}</div>,
          HandleClose: () => setErrorModal({ ...errorModal, Show: false })
        });
        setIsShowLoading(false);
        return;
      }

      setToaster({
        Title: "Success",
        Show: true,
        Message: `${testerId} has been deleted successfully.`,
        ShowSuccessCheck: true,
        ClassName: "toaster-error",
        OnClose: onToasterClose,
      });
      setIsShowLoading(false);
      navigate("/");
    }).catch((error: any) => {
      const message = error?.statusMessage || error?.message || "An unexpected error occurred while deleting tester";
      console.error("SaveTester (delete) exception:", error);
      setErrorModal({
        Title: "Error",
        Show: true,
        Component: <div>{message}</div>,
        HandleClose: () => setErrorModal({ ...errorModal, Show: false })
      });
      setIsShowLoading(false);
    });
  };

  return (
    <>
      <ErrorComponentModel modal={errorModal} />
      {isAuthorized("AV_Tester_View") ? (
        <div className="page-container">
          <Row>
            <Col>
              <Row>
                <Col>
                  <Card className="card-parent">
                    <Accordion defaultActiveKey="0" className="accordion-parent">
                      <Accordion.Item eventKey="0">
                        <Accordion.Header
                          className="accordion-toggle col-sm-12"
                        >
                          <h5 className="mb-0">Tester Information</h5>
                        </Accordion.Header>
                        <Accordion.Body className="col-sm-12 mb-0">
                          {testerEditMode || testerId === 0 ? (
                            <EditTester
                              testerId={testerId}
                              onCancel={OnCancel}
                              onSuccess={OnSuccess}
                            ></EditTester>
                          ) : (
                            <ViewTester testerId={testerId} onEdit={() => setTesterEditMode(true)} onDelete={onDeleteConfirmation} />
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Card>
                </Col>
              </Row>
              {testerId > 0 && (
                <Row>
                  <Col>
                    <Vehicles testerId={testerId} isNewTester={testerid === "0"} />
                  </Col>
                </Row>
              )}
            </Col>
            <ToasterModel toaster={toaster}></ToasterModel>
            <ConfirmationModel modal={modal}></ConfirmationModel>
          </Row>
          {isShowLoading && <Spinner></Spinner>}
        </div>
      ) : (
        <NotAuthorized />
      )}
    </>
  );
}
//}

export default withAITracking(reactPlugin, TesterDetails);
